import { RefObject, useEffect, useState } from "react";

interface Image {
  imageUrl: string;
  title: string;
}

interface UseCanScrollProps {
  thumbnailsRef: RefObject<HTMLDivElement>;
  galleryObjects: Image[];
}

export const useCanScroll = ({ thumbnailsRef }: UseCanScrollProps) => {
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const scrollListener = () => {
    if (!thumbnailsRef.current) {
      return;
    }
    setCanScrollUp(thumbnailsRef.current.scrollTop !== 0);
    setCanScrollDown(
      !(
        Math.round(
          thumbnailsRef.current.scrollTop + thumbnailsRef.current.clientHeight,
        ) >= thumbnailsRef.current.scrollHeight
      ),
    );
  };

  useEffect(() => {
    if (thumbnailsRef.current) {
      setTimeout(() => {
        scrollListener();
      }, 500);
    }
  }, []);

  useEffect(() => {
    if (thumbnailsRef.current) {
      thumbnailsRef.current.addEventListener("scroll", scrollListener);
      window.addEventListener("resize", scrollListener);
    }

    return () => {
      if (thumbnailsRef.current) {
        thumbnailsRef.current.removeEventListener("scroll", scrollListener);
        window.removeEventListener("resize", scrollListener);
      }
    };
  }, [thumbnailsRef]);

  return { canScrollDown, canScrollUp };
};
